<template>
    <!-- /3336232/300//250 -->
    <div class="w-full overflow-hidden m-auto px-0 sm:px-6 lg:px-8 text-center  transition-all">
        <ins class="adsbygoogle hidden lg:block mx-auto" data-ad-client="ca-pub-5486214968700891" data-ad-slot="3633561207"
            data-ad-format="auto" data-full-width-responsive="true"></ins>

        <ins class="adsbygoogle block md:hidden mx-auto" style="width:320px;height:100px" data-ad-client="ca-pub-5486214968700891"
            data-ad-slot="8205274065"></ins>

        <ins class="adsbygoogle hidden md:block lg:hidden mx-auto" style="height:90px"
            data-ad-client="ca-pub-5486214968700891" data-ad-slot="8205274065"></ins>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isRendered: false
        }
    },
    mounted() {
        setTimeout(function () {
            (adsbygoogle = window.adsbygoogle || []).push({});
        }, 3e3)
    },
    created() {
        //(adsbygoogle = window.adsbygoogle || []).push({});
    }
}
</script>
<style>
ins.adsbygoogle[data-ad-status="unfilled"] {
    display: none !important;
}

/* Custom styles for the 300x100 ad size */
.ad-300x100 {
    width: 320px;
    height: 100px;
    /* Add other styles as needed */
}

/* Hide 300x100 ad on screens larger than 768px (medium breakpoint) */
@media (min-width: 769px) {
    .ad-300x100 {
        display: none;
    }
}

/* Hide 728x90 ad on screens smaller than 768px (medium breakpoint) */
@media (max-width: 768px) {
    .ad-728x90 {
        display: none;
    }
}

/* Hide other ad sizes on screens larger than 768px (medium breakpoint) */
@media (min-width: 769px) {

    .ad-320x100,
    .ad-728x90 {
        display: none;
    }
}
</style>